export class URLWrapper {
	static readonly urls = {
		auth: {
			loginUrl: "/auth/login", //POST
			loginData: "/auth/login/data",
			openEdxloginData: "/auth/openedx-login/data",
			refreshSessionToken: "/auth/refresh-session-token", //POST
			SocialAuth: "/auth/social/login",//post
			Linkedinlogin: "/auth/linkedin",//post
			register: {
				user: "/auth/register/user", //POST
				// resendVerifyMail: "/auth/register/user/resendmail",
				// community: "/auth/register/community", //POST
				invite: "/auth/register/invite", //POST
				link: "/auth/register/invite/link" //POST
			},
			Linkedin: {
				base_url: 'https://www.linkedin.com/oauth/v2',
				base_url_api: 'https://api.linkedin.com/v2',
				email: '/emailAddress?q=members&projection=(elements*(handle~))',
				profile: '/me',
				profilephoto: '/me?projection=(id,profilePicture(displayImage~digitalmediaAsset:playableStreams))'
			},
			existing: {
				invite: "/auth/existing/invite", //POST
			},

			password: {
				forgotPassword: "/auth/password/forgot", //POST
				resetPassword: "/auth/password/reset" //POST
			},
			emailVerification: "/auth/email/verification/resend", //POST,
			loginVerify: "/auth/login/verify", //POST
			logout: "/profile/logout", //POST
			lockscreen: {
				lockscreen: "/auth/lockscreen",//POST
				lockscreenview: "/auth/lockscreen/view",//GET
				lockscreenList: "/auth/lockscreen/list",//GET — community + its spaces, for the landing-pages listing
				lockscreenAuth: "/auth/lockscreen/auth",
				lockscreenDelete: "/auth/lockscreen/delete"
			},
			ShareableUrl: {
				CreateShareableUrl: "/auth/shareableurl",//POST
				GetShareableUrl: "/auth/shareable/post/content",//GET,
				GetCommunityShareableUrl: "/auth/shareable/community"//GET
			},
		},
		posts: {
			url: "/posts", //ALL CRUD
			lookupByIds: "/posts/lookup-by-ids",
			analytics: "/posts/analytics",
			like: "/posts/like",
			share: "/posts/share",
			comments: "/posts/comment",
			commentLike: "/posts/comment/like",
			commentReport: "/posts/comment/report",
			report: "/posts/report",
			pinToMediaCenter: "/posts/pin",
			uploadMedia: "/posts/upload/media",
			createExternalPosts: "/posts/external",

			amp: {
				like: "/posts/amp/like",
				unLike: "/posts/amp/unlike",
				likeStatus: "/posts/amp/like/status",
				addComment: '/posts/amp/add/comments',
				comments: '/posts/amp/get/comments',
				submitPolls: '/posts/amp/submit/polls',
				pollResults: '/posts/amp/poll/results',
				submitSurvey: '/posts/amp/survey/submit',
				surveyResults: '/posts/amp/survey/results',
				eventResults: '/posts/amp/event/results',
				verificationEmail: '/posts/amp/verification-mail',
			},

		},
		profile: {
			url: "/profile",
			profile: "/profile",
			profileUpdate: "/profile/update",
			profileBrief: "/profile/brief",
			profileView: "/profile/view",
			profileViewBrief: "/profile/view/brief",
			profileVisits: "/profile/visits",
			profileCommunities: "/profile/communities", //All CRUD
			profileCommunitiesBrief: "/profile/communities/brief",
			shareTargets: "/profile/share-targets", //GET — where a piece of content may be posted
			profileCommunityInvitations: "/profile/community/invitations",
			profileCommunityRequests: "/profile/community/requests",
			// createCommunity: "/createCommunity",
			// deleteCommunity: "/deleteCommunity",
			// profileConnections: "/profile/connections",
			joinCommunity: "/profile/community/join", //POST Action,
			about: "/profile/about",
			email: "/profile/email",
			industry: '/profile/industry',
			explorePopUp: "/profile/explorepopup",
			activity: "/profile/activities",
			online: "/profile/online",
			changePassword: "/profile/password",
			details: "/profile/details", //ALL CRUD
			connections: "/profile/connections", //ALL CRUD
			expertise: "/profile/expertise", //ALL CRUD
			expertiseAll: "/profile/expertise/all", //ALL CRUD
			interests: "/profile/interests", //ALL CRUD
			interestsAll: "/profile/interests/all", //ALL CRUD
			experience: "/profile/experience", //ALL CRUD
			education: "/profile/education", //ALL CRUD
			notification: "/profile/notifications", //ALL CRUD
			connectionRequests: "/profile/connectionRequests",
			communintyInvite: "/profile/connection/community/request",
			InviteinviteRequest: "/profile/community/inviteRequest",
			settings: "/profile/setting",
			readNotification: "/profile/notifications/read",
			// InviteAccept: "/profile/community/inviteRequest",
			openCommunitySection: "/profile/open-community-section", //All CRUD

			identity: {
				sumsub: "/profile/identity/sumsub",
			},
			follow: "/profile/follow",
		},
		message: {
			messageAllUrl: "/message/p2p", //GET Call
			messageGroupsUrl: "/message/groups", //CRUD
			messageGroupsPeople: "/message/groups/people", //CRUD
			messageChannelMember: "/messagesv2/channel/member", //CRUD
			messageToken: "/message/token", //GET Call
			recent: "/message/recent"
		},
		messageV2: {
			group: "/messagesv2/group",
			groupMembers: "/messagesv2/group/members",
			groupMessage: "/messagesv2/group/message",
			all: "/messagesv2/all",
			note: "/messagesv2/note",
			calendly: "/messagesv2/calendly",
			cacheInvalidationViaTriggers: "/messagesv2/cache",
			huddle: {
				token: "/messagesv2/huddle/token", // GET
				link: "/messagesv2/huddle/link", // GET
				user: "/messagesv2/huddle/user", // GET
				channel: "/messagesv2/huddle/channel", // GET
				status: "/messagesv2/huddle/status", // POST
				mattermostUser: "/messagesv2/huddle/mattermost-user", // GET
				rooms: "/messagesv2/agora/rooms",
				hook: "/messagesv2/agora/hook",
				invite: "/messagesv2/agora/invite",
				validate: "/messagesv2/agora/validate",
				addAttendee: "/messagesv2/agora/add-attendee",
				captionLanguages: "/messagesv2/agora/captions/languages", // POST
				endRoom: "/messagesv2/agora/room/end", // POST
				recordings: "/messagesv2/agora/recordings", // GET
				recordingDownload: "/messagesv2/agora/recordings/download", // GET
			}
		},
		push: {
			sendPush: "/messagesv2/api/v1/send_push",
			ack: "/messagesv2/api/v1/ack",
		},
		poll: {
			url: "/polls",
			submit: "/polls/submit",
			end: "/polls/end",
			download: "/polls/download",
		},
		survey: {
			url: "/surveys",
			submit: "/surveys/submit",
			end: "/surveys/end",
			download: "/surveys/download",
		},
		recommendation: {
			type: "/recommendations/type", //GET Call
			get: "/recommendations/get" //GET Call
		},
		community: {
			all: "/community", // ALL CRUD

			token: "/community/token",
			tokenData: "/community/token-data",

			specific: "/community/one", // ALL CRUD
			infoMap: "/community/infoMap", // ALL CRUD
			specificBrief: "/community/one/brief", // ALL CRUD
			getMattermostChannels: "/community/one/mattermost-channels", // GET
			feedback: "/community/one/feedback", // POST

			termsCondition: "/community/termsCondition",
			privacyPolicy: "/community/privacyPolicy",
			termsConditionprivacyPolicy: "/community/termsConditionprivacyPolicy",

			qni: "/community/one/qni",

			readableId: "/community/readable-id",
			checkReadableId: "/community/check-readable-id",

			/*
			 * Personalised setup checklist shown on /onboarding-checklist. The GET resolves
			 * every row's status live, so it is safe to call on each render; the toggle only
			 * accepts rows the system cannot judge for itself.
			 */
			onboardingChecklist: "/community/onboarding-checklist",
			onboardingChecklistToggle: "/community/onboarding-checklist/toggle",

			/*
			 * Which features this community has switched on. MEMBER-level on purpose: the upsell
			 * screen has to be decidable by anyone, and the admin listing at
			 * `commnunnityAdmin.settings.features` cannot serve it — that one requires
			 * ViewCommunitySettings and writes `onboardingFlags` as a side effect of the GET.
			 */
			features: "/community/features",

			unreadMentions: "/community/unread-mentions",

			pendingApprovalPosts: "/community/pending-approval-posts",
			userBlock: "/community/user/block",
		},
		commnunnityAdmin: {

			acquisition: {
				summary: "/admin/community/acquisition/summary", //GET
				rows: "/admin/community/acquisition/rows", //GET
				funnels: "/admin/community/acquisition/funnels", //GET
				timeline: "/admin/community/acquisition/timeline", //GET
				stagePeople: "/admin/community/acquisition/stage-people", //GET
				activity: "/admin/community/acquisition/activity", //GET
			},

			/**
			 * Admin content listings — every unit across the main community AND all its spaces.
			 * `scopes` backs the space-filter dropdown (unpaginated id + name); deliberately NOT
			 * `/admin/community/spaces`, which is paginated and fans out into privileges,
			 * feedback and child counts.
			 */
			content: {
				scopes: "/admin/community/content/scopes",
				feed: "/admin/community/content/feed",
				events: "/admin/community/content/events",
				offers: "/admin/community/content/offers",
				jobs: "/admin/community/content/jobs",
				services: "/admin/community/content/services",
				fundraisings: "/admin/community/content/fundraisings",
				courses: "/admin/community/content/courses",
				mediaCenter: "/admin/community/content/media-center",
			},
			communityRequests: "/admin/community/requests", //ALL CRUD
			communityRequestsExport: "/admin/community/requests/export",
			communityRequestPopUp: "/admin/community/requests/notification",

			communityNominations: "/admin/community/nomination",
			communityNominationsExport: "/admin/community/nomination/export",
			communityNominationPopUp: "/admin/community/nomination/notification",

			spaces: "/admin/community/spaces", //ALL CRUD

			// Get or set either community's or Space details
			communitySpaceDetails: "/admin/community/spaces/one", //ALL CRUD
			communityAnalytics: "/admin/community/analytics", //ALL CRUD

			users: "/admin/community/users", //ALL CRUD
			exportUsers: "/admin/community/users/export",
			userRoles: "/admin/community/users/roles",
			removeUsers: "/admin/community/users/remove", //ALL CRUD

			// Custom Profile Fields & Layout
			profileFields: "/admin/community/profile-fields", //ALL CRUD (DELETE = archive)
			profileConfig: "/admin/community/profile-config", //GET/PUT layout config

			feedbacks: "/admin/community/feedbacks", //ALL CRUD

			newAffiliatedTags: "/admin/community/tags/multiple",
			invites: "/admin/community/invites", //ALL CRUD


			outgoingInvites: "/admin/community/invites/outgoing",
			outgoingInvitesExport: "/admin/community/invites/outgoing/export",
			allOutgoingInvites: "/admin/community/invites/outgoing/all",
			communityInvitesnPopUp: "/admin/community/invites/outgoing/notification",

			classification: {
				exiting: "/admin/community/classification",
				new: "/admin/community/classification/multiple"
			},

			settings: {
				url: "/admin/community/settings",

				admin: "/admin/community/settings/admin", // In Use - But we be discarded
				morderatorGet: "/admin/community/settings/morderator",
				morderatorAdd: "/admin/community/settings/morderator",
				morderatorRemove: "/admin/community/settings/morderator",

				unblockUsers: "/admin/community/settings/unblockusers",
				blockedUsers: "/admin/community/settings/blockusers",

				permissions: "/admin/community/settings/permissions",
				resetPermissions: "/admin/community/settings/reset-permissions",
				warningStatus: "/admin/community/settings/permissions-warning-status",
				spaceDefaultSettings: "/admin/community/space/settings/default",

				notifications: "/admin/community/settings/notifications",

				features: "/admin/community/settings/features",
				featuresBulkUpdate: "/admin/community/settings/features/bulk-update",
				/*
				 * Toggle ONE feature across several SPACES, from the community's own token.
				 *
				 * The existing feature routes resolve their target from `communityToken`, so
				 * switching a feature on for a space would otherwise mean minting a group token per
				 * space just to flip one flag. This takes the space ids instead and verifies each is
				 * a child of the caller's community.
				 */
				featuresForSpaces: "/admin/community/settings/features/spaces",

				roles: "/admin/community/settings/roles",
				rolePrivileges: "/admin/community/settings/roles/privileges",
				roleRestrictions: "/admin/community/settings/roles/restrictions",
				access: "/admin/community/settings/access",
				renameFeatures: "/admin/community/settings/rename-features",
				messageRestriction: "/admin/community/settings/message/restriction",
			},

			communityAdminColour: "/admin/community/colour",

			// Community-admin external-vendor API-key + webhook management (the developer/API
			// section in fe-main admin-pages). Mirrors platformAdmin.externalVendor but scoped to
			// the caller's own community — communityId comes from the community token, not the body.
			externalVendor: {
				createAPIKey: "/admin/community/external-vendor/api-key",
				getAPIKey: "/admin/community/external-vendor/api-key/get",
				deleteAPIKey: "/admin/community/external-vendor/api-key/delete",
				createWebhookSubscription: "/admin/community/external-vendor/subscribe-webhook",
				getWebhookSubscription: "/admin/community/external-vendor/webhook/get",
				verifyWebhookUrl: "/admin/community/external-vendor/webhook/verify",
				updateWebhookSubscription: "/admin/community/external-vendor/webhook/update",
				// Webhooks v2: several endpoints per community. list/create/update/delete share one path (GET/POST/PUT/DELETE).
				webhooks: {
					list:       "/admin/community/external-vendor/webhooks",
					create:     "/admin/community/external-vendor/webhooks",
					update:     "/admin/community/external-vendor/webhooks",
					delete:     "/admin/community/external-vendor/webhooks",
					rollSecret: "/admin/community/external-vendor/webhooks/secret",
					testSend:   "/admin/community/external-vendor/webhooks/test",
					deliveries: "/admin/community/external-vendor/webhooks/deliveries",
					delivery:   "/admin/community/external-vendor/webhooks/delivery",
					resend:     "/admin/community/external-vendor/webhooks/resend",
					catalog:    "/admin/community/external-vendor/webhooks/catalog",
				},
			},

			nominations: {
				url: "/community/nomination", // CR
				existig: "/community/nomination/existing",
				request: "/community/nomination/request",
				bulk: "/community/nomination/bulk"
			},

			tagRestriction: "/admin/community/tagRestriction",

			// Invites and Bulk Invite below this

			invitesExisting: "/admin/community/invites/existing", //ALL CRUD
			invitesEmail: "/admin/community/invites/emails", //ALL CRUD
			invitesEmailCommonTagNote: "/admin/community/invites/emails/common",
			invitesBulk: "/admin/community/invites/bulk", //ALL CRUD

			invitesBulkValidation: "/admin/community/bulk-invites/validation/upload",
			invitesEmailBulkValidation: "/admin/community/bulk-invites/validation/email",
			inviteBulkTemplate: "/admin/community/bulk-invite/template",
			addExternalUsers: "/admin/community/addExternalUsers",

			csv: {
				files: "/admin/community/bulk-invite/csvs",
				entries: "/admin/community/bulk-invite/csvs/entries",
				downloadFailed: "/admin/community/bulk-invite/csvs/download/failed"
			},

			identity: {
				profile: "/admin/community/identity"
			},

			oneSignal: {
				provision: "/admin/community/one-signal/provision",
				status: "/admin/community/one-signal/status",
			},
			posthog: {
				// GET returns the stored analytics dashboard embed URL; PUT sets/clears it (admin only)
				embed: "/admin/community/posthog/embed",
			},
			// Branded ("Networked Plus") mobile app. GET drives all five page stages in one call;
			// POST submits/updates the ops intake; terms records agreement acceptance.
			// promptEvent records the upsell popup being shown / dismissed / tapped.
			mobileApp: {
				url: "/admin/community/mobile-app",
				terms: "/admin/community/mobile-app/terms",
				promptEvent: "/admin/community/mobile-app/prompt-event",
				// Service-only (shared-secret header, no session): run by a scheduled job.
				promptReminders: "/admin/community/mobile-app/prompt-reminders",
			},
			website: {
				siteLayout:      "/admin/community/website/site-layout",
				pages:           "/admin/community/website/pages",
				page:            "/admin/community/website/pages/:pageId",
				pagePublish:     "/admin/community/website/pages/:pageId/publish",
				pagePrimary:     "/admin/community/website/pages/:pageId/primary",
				pageLayoutFlags: "/admin/community/website/pages/:pageId/layout-flags",
				pageSeo:         "/admin/community/website/pages/:pageId/seo",
				pageSlug:        "/admin/community/website/pages/:pageId/slug",
				pageName:        "/admin/community/website/pages/:pageId/name",
				contentList:     "/admin/community/website/content/list",
				contentResolve:  "/admin/community/website/content/resolve",
			},
			emailProvider: {
				create: "/admin/community/email-provider",
				update: "/admin/community/email-provider",
				delete: "/admin/community/email-provider",
				list:   "/admin/community/email-provider",
				test:   "/admin/community/email-provider/test",
			},
			// Token usage for the community in communityToken (token slice 3a).
			tokens: {
				usage: "/admin/community/tokens/usage",
				prices: "/admin/community/tokens/prices",
			},
			sesTenant: {
				get:           "/admin/community/ses-tenant",
				domainRequest: "/admin/community/ses-tenant/domain",
				domainStatus:  "/admin/community/ses-tenant/domain/status",
				ipRequest:     "/admin/community/ses-tenant/ip",
				ipStatus:      "/admin/community/ses-tenant/ip/status",
				ipPurpose:     "/admin/community/ses-tenant/ip/purpose",
				ipRemove:      "/admin/community/ses-tenant/ip", // DELETE (spec 2026-10-13 §3.4)
			},
		},
		communityMorderator: {
			url: "/moderator",
			post: "/moderator/post",
			declinePost: "/moderator/post/decline",
			oppurtunity: "/moderator/oppurtunity",
			user: {
				url: "/moderator/user",
				block: "/moderator/user/block",
				invite: "/moderator/user/invite"
			}
		},

		platformAdmin: {
			community: "/platform/admin/community",
			communityEmailFlag: "/platform/admin/community/email",
			communityExploreFlag: "/platform/admin/community/explore",
			communityDynamicLink: "/platform/admin/community/dynamic-link",
			communityAnalytics: "/platform/admin/community/analytics",
			configureHubCommunity: "/platform/admin/community/configure-hub",
			user: "/platform/admin/user",
			userPassword: "/platform/admin/user/password",
			communityFeture: "/platform/admin/community/feature",
			feature: "/platform/admin/feature",
			industry: {
				url: "/platform/admin/industry",
			},
			uploadUser: "/platform/admin/upload/user",
			uploadExperience: "/platform/admin/upload/experience",
			uploadExperienceUpdate: "/platform/admin/upload/experience/update",
			uploadEducation: "/platform/admin/upload/education",
			uploadEducationUpdate: "/platform/admin/upload/education/update",
			uploadExpertise: "/platform/admin/upload/expertise",
			uploadExpertiseGCA: "/platform/admin/upload/expertisegca",
			uploadIndustry: "/platform/admin/upload/industry",
			uploadIndustryGCA: "/platform/admin/upload/industrygca",
			interestGCA: "/platform/admin/upload/interestmatch",
			uploadCommunity: "/platform/admin/upload/community",
			login: "/platform/admin/login",
			/** */
			termsConditionPrivacy: "/community/platform/termsCondition", //Shift this to community
			privacyPolicy: "/community/platform/privacyPolicy", //Shift this to community
			generateWeeklyReport: "/platform/admin/generateWeeklyReport",
			script: {
				sig: '/platform/admin/community/sig-data-mapping'
			},
			invitation: "/platform/admin/community/invitation",
			invitationRecent: "/platform/admin/community/invitation-recent",
			invitationUpdate: "/platform/admin/community/invitation-update",
			externalVendor: {
				createAPIKey: "/platform/admin/external-vendor/api-key",
				getAPIKey: "/platform/admin/external-vendor/api-key/get",
				deleteAPIKey: "/platform/admin/external-vendor/api-key/delete",
				createWebhookSubscription: "/platform/admin/external-vendor/subscribe-webhook",
				getWebhookSubscription: "/platform/admin/external-vendor/webhook/get",
				verifyWebhookUrl: "/platform/admin/external-vendor/webhook/verify",
				updateWebhookSubscription: "/platform/admin/external-vendor/webhook/update",
				// Webhooks v2 mirror of commnunnityAdmin.externalVendor.webhooks; communityId in body/query.
				webhooks: {
					list:       "/platform/admin/external-vendor/webhooks",
					create:     "/platform/admin/external-vendor/webhooks",
					update:     "/platform/admin/external-vendor/webhooks",
					delete:     "/platform/admin/external-vendor/webhooks",
					rollSecret: "/platform/admin/external-vendor/webhooks/secret",
					testSend:   "/platform/admin/external-vendor/webhooks/test",
					deliveries: "/platform/admin/external-vendor/webhooks/deliveries",
					delivery:   "/platform/admin/external-vendor/webhooks/delivery",
					resend:     "/platform/admin/external-vendor/webhooks/resend",
					catalog:    "/platform/admin/external-vendor/webhooks/catalog",
				},
			},
			oneSignal: {
				provision: "/platform/admin/community/one-signal/provision",
			},
			// Branded mobile app, staff side. The only way a record leaves ContractPending —
			// fulfilment is manual, so these are how the person doing the work records progress.
			mobileApp: {
				url:         "/platform/admin/community/mobile-app",
				status:      "/platform/admin/community/mobile-app/status",
				storeStatus: "/platform/admin/community/mobile-app/store-status",
				markPaid:    "/platform/admin/community/mobile-app/mark-paid",
			},
			// Token usage for any root community, and the calibration list (token slice 3a).
			tokens: {
				usage:       "/platform/admin/tokens/usage",
				communities: "/platform/admin/tokens/communities",
			},
			emailTenant: {
				list:         "/platform/admin/email-tenants",
				revokeDomain: "/platform/admin/email-tenants/domain",
				revokeIp:     "/platform/admin/email-tenants/ip",
			},
		},
		oppurtunity: {
			events: "/oppurtunity/events",
			services: "/oppurtunity/services",
			questions: {
				url: "/oppurtunity/questions",
				follow: "/oppurtunity/questions/follow",
				answers: {
					url: "/oppurtunity/questions/answers",
					likes: "/oppurtunity/questions/answer/likes",
					follow: "/oppurtunity/questions/answer/follow",
					comments: {
						url: "/oppurtunity/questions/answer/comments",
						likes: "/oppurtunity/questions/answer/comments/likes"
					}
				}
			},
			fundraising: "/oppurtunity/fundraising",
			jobs: {
				url: "/oppurtunity/jobs",
				applicants: "/oppurtunity/jobs/applicants",
				applied: "/oppurtunity/jobs/applied",
				posted: "/oppurtunity/jobs/posted"
			},
			share: "/oppurtunity/share"
		},
		globalRoutes: {
			classifications: "/global/classifications/all",
			industries: "/global/industries/all",
			communities: "/global/comunities/all",
			featureUpdate: "/global/feature/update",
			tagUpdate: "/global/tag/update",
			communityUsersExport: "/global/community-users/export",
			communityUsersUpdate: "/global/community-users/update",
			addUserToDefaultCommunity: "/global/user/defaultcom",
			addUCSUToCommunity: "/global/user/addcsu",
			invitationUpdate: "/global/invitation/update",
			invitationNomUpdate: "/global/invitationnom/update",
			userSettingsUpdate: "/global/usersettings/update",
			mcPUpdate: "/global/mcP/update",
			mcPUpdate2: "/global/mcP/update/prod",
			nameUpdate: "/global/name/update",
			// users: "/users/all", //Removed this routing due to security reasons
			// usersExceptCommunity: "/users/allNotInCommunity",
			usersNotInvited: "/global/users/notinvited/all",
			communityUsers: "/global/users/community",
			// communityAllUsers: "/users/community/all",

			tags: "/global/tags/all",
			communityTags: "/global/tags/community",
			jobTypes: "/global/jobtypes/all",
			roundTypes: "/global/roundtypes/all",
			salaryDurationTypes: "/global/salarydurationtypes/all",
			salaryTypes: "/global/salarytypes/all",
			startUpTypes: "/global/startuptypes/all",
			currencies: "/global/currencies/all",
			specialities: "/global/specialities/all",
			explore: "/global/explore",
			explorePopUp: "/global/explore/notification",
			exploreOne: "/global/explore/one",
			encrptMobileNumber: "/global/user/mobile",
			usersMainPublicCommunityExceptCurrCmnty: "/global/users/PublicCommunityExceptCurrCmnty",
			convertExistingCommunityRequest: "/global/creq",
			platformFeedback: "/global/feedback",
			zoom: "/global/zoom",
			/** */

			createMobileLink: "/global/mobile/link",
			createAppLink: "/global/app/link",
			refer: "/global/refer/link",
			referSSO: "/global/refer/sso",

			referUpdate: "/global/refer/update",
			handlebar: "/global/handlebar",

			updateEvents: "/eventUpdate",

			tokens: {
				session: "/global/tokens/session",
				community: "/global/tokens/community",
				gate: "/global/tokens/gate",
				// group: "/global/tokens/group" // This will automatically be sufficed by the community token
			},
			openedx: {
				authToken: "/global/open-edx/auth-token",
				enrollCourse: "/global/open-edx/enroll-course",
				togglePublish: "/global/open-edx/courses",
				course: "/global/open-edx/courses",
				settings: "/global/open-edx/courses-settings", // put
				mycourse: "/global/open-edx/my-courses",
				upload: "/global/open-edx/assets",
				updateProfile: '/global/open-edx/user/update-profile-image'
			},
			offers: {
				base: "/global/offers",
				slugAvailable: "/global/offers/slug-available",
				bySlug: "/global/offers/slug/:slug",
				myPurchases: "/global/offers/my-purchases",
				typeCounts: "/global/offers/type-counts",
				byId: "/global/offers/:offerId",
				checkout: "/global/offers/:offerId/checkout",
				claim: "/global/offers/:offerId/claim",
				reviews: "/global/offers/:offerId/reviews",
				reviewById: "/global/offers/:offerId/reviews/:reviewId",
				purchases: "/global/offers/:offerId/purchases",
				content: "/global/offers/:offerId/content",
			},
			websiteRender: {
				siteLayout: "/global/website-render/:communitySlug/site-layout",
				page:       "/global/website-render/:communitySlug/pages/:slug",
				primary:    "/global/website-render/:communitySlug/primary",
				pages:      "/global/website-render/:communitySlug/pages",
			},
			websiteRenderByDomain: {
				siteLayout: "/global/website-render-by-domain/site-layout",
				page:       "/global/website-render-by-domain/pages/:slug",
				primary:    "/global/website-render-by-domain/primary",
				pages:      "/global/website-render-by-domain/pages",
			},
			websiteRss: {
				resolve: "/global/website-rss/resolve",
			},
			websiteContent: {
				resolve: "/global/website-content/resolve",
			},
			emailAnalytics: {
				webhook:    "/global/email-analytics/webhook",
				snsWebhook: "/global/email-analytics/sns-webhook",
				sendTest:   "/global/email-analytics/send-email",
				dashboard:  "/global/email-analytics/dashboard",
				export:     "/global/email-analytics/export",
				// Digest analytics — scope EMAIL_DIGEST_SENT, rendered below the global section
				digest:     "/global/email-analytics/digest",
				// Tables split out from /dashboard so sorting or paging one does not
				// recompute the KPI aggregate above it
				sends:      "/global/email-analytics/sends",
				domains:    "/global/email-analytics/domains",
				links:      "/global/email-analytics/links",
				// Recipient list + per-recipient analytics as a downloadable file
				recipientExport: "/global/email-analytics/recipients/export",
			},
		},
		public: {
			getCommunityByEmail: "/global/public/communitybyemail",
			leaveCommunity: "/global/public/leave-community",
			unsubscribeContext: "/global/public/unsubscribe-context",
			unsubscribeApply: "/global/public/unsubscribe",
			unsubscribeOneClick: "/global/public/unsubscribe-one-click",
			resubscribe: "/global/public/resubscribe"
		},
		scrapeUrls: {
			url: "/global/scrape",
			bulkUrl: "/global/bulkScrape",
			v2: "/scrape"//This is without any /api/v1
		},
		shareable: {
			url: "/shareableLink"
		},
		fileUrl: {
			url: "/bucket"
		},

		//Can be removed later. Has duplicate in profile
		setting: {
			user: "/profile/setting"
		},

		profanity: {
			get: "/admin/community/profanity/",
			getPosts: "/admin/community/profanity/posts",
			getReportedBy: "/admin/community/profanity/reportedby"
		},
		oneRoutes: {
			service: "/global/services/one",
			job: "/global/jobs/one",
			fundraising: "/global/fundraisings/one",
			events: "/global/events/one",
			post: "/global/posts/one"
		},
		analytics: {
			popup: "/admin/analytics/popup",
			dashboard: "/admin/analytics/dashboard"
		},

		invitationUrl: {
			url: '/community/invitation',
			publicInfo: '/community/invitation/public',
			list: '/community/invitation/list',
			recent: '/community/invitation/recent',
			status: '/community/invitation/status',
			verify: '/community/invitation/verify'
		},

		// -------------------------------------------------- Plugin URLS

		mediaCenter: {
			base: "/mcenter",
			upload: "/mcenter/v1/upload",
			videoLink: "/mcenter/v1/link",
			generalLink: "/mcenter/v1/general/link",
			get: "/mcenter/v1/get",
			remove: "/mcenter/v1/remove",
			move: "/mcenter/v1/move",
			rename: "/mcenter/v1/rename",
			pinToTop: "/mcenter/v1/pintotop",
			share: "/mcenter/v1/share",
			folder: "/mcenter/v1/folder",
			download: "/mcenter/v1/folder/download",
			downloadLog: "/mcenter/v1/download-log",
			info: "/mcenter/v1/folder/info",
			size: "/mcenter/v1/folder/size",
			thumbnail: "/mcenter/v1/thumbnail",
			tags: '/mcenter/v1/tags',
			mediaTags: '/mcenter/v1/mediaTags',
			users: '/mcenter/v1/users',
			customList: '/mcenter/v1/customList',
			customListTags: '/mcenter/v1/customListTags',
			customListMediaTags: '/mcenter/v1/customListMediaTags',
		},


		plugin: {
			platformAdmin: "/plugin/platform",
			communityAdmin: {
				plugin: "/plugin/community",
				hubspot: "/plugin/community/hubspot",
				available: "/plugin/community/available",
				salesforceCallBack: "/plugin/community/salesforceCallBack",
				salesforceUserInfo: "/plugin/community/salesforceUserInfo",
				syncSalesforceContacts: "/plugin/community/syncSalesforceContacts",
			},
			user: {
				plugin: "/plugin/user",
				available: "/plugin/user/available"
			}
		},

		// -------------------------------------------------- PHASE 2 URLS

		childCommunity: {
			url: "/admin/community/child/v2",
			url2: "/admin/community/child/v3",
		},

		stripe: { //appends "/stripe" automatically
			hooks: "/hook",
			identityWebhook: "/hook/identity",
			accountHooks: "/hook/account",
			customerPortal: "/customer/portal",
			getConnectLink: '/get-connect-link',
			webhook: '/webhook',
			updateSubscription: '/update-subscription',
			checkPaymentMethod: '/payment-method',
			checkoutSessionUrl: '/checkout-session-url',
			getSubscriptionDetails: '/subscription-details',
			extendTrial: '/extend-trial',
			availablePlans: '/plans/available',
			// The Networked Plus (branded mobile app) ladder. Separate from availablePlans on
			// purpose — see networked-plus-plans.ts for why these products must stay out of that
			// endpoint's discovery query.
			networkedPlusPlans: '/plans/networked-plus',
			// The same ladder for platform admins (no community token) — fe-admin's mark-paid dialog.
			platformNetworkedPlusPlans: '/platform/plans/networked-plus',
			mobileAppCheckout: '/mobile-app/checkout',
			cancelSubscription: '/cancel-subscription',
			downgradeSubscription: '/downgrade-subscription',
			toggleCommunityStatus: '/toggle-status',
			monetization: {
				account: "/monetization/accounts",
				plans: "/monetization/plans",
				spaces: "/monetization/spaces",
				dashboard: "/monetization/express",
				callback: "/monetization/callback",
				users: {
					// base: "/monetization/user",
					paymentMethod: "/monetization/user/payment-methods",
					customerPortal: "/monetization/user/portal",
					registerAndCharge: "/monetization/user/register",
					refundRequest: "/monetization/users/refund-request"
				},
				/*
				 * ADMIN-side purchase records. A member gets all of this from Stripe's customer
				 * portal, which is already wired; what the portal cannot do is show an admin the
				 * whole community's billing, or let them refund someone.
				 */
				purchases: {
					list: "/monetization/purchases",
					refund: "/monetization/purchases/refund",
					cancel: "/monetization/purchases/cancel",
					/** The caller's OWN purchases. No userId -- see purchase-routes.ts. */
					mine: "/monetization/purchases/mine",
					/** A member moves between plans, on the admin's configured terms. */
					changePlan: "/monetization/purchases/change-plan",
					invoice: "/monetization/purchases/invoice",
				}
			},
			identity: {
				cancelSubscription: "/identity/cancel",
			},
			offer: {
				product: "/offer/product",
				price: "/offer/price",
				checkout: "/offer/checkout",
			},
		},

		events: {
			url: "/events", //ALL CRUD
			yourEvents: "/events/yourevents",
			otherEvents: "/events/otherevents",
			hostingEvents: "events/hosting",
			goingEvents: "/events/going",
			register: "/events/register",
			registrationForm: "/events/registration-form",
			share: "/events/share",
			eventUsers: "/events/users",
			registeredUsers: "/events/users/going",
			interestedUsers: "/events/users/interested",
			userExport: "/events/users/export",
			analytics: "/events/analytics",
			publish: "/events/publish",
			calendar: "/events/calendar.ics"
		},

		groups: {
			url: "/admin/community/groups",
			about: "/admin/community/groups/about",
			pin: "/admin/community/groups/pin",
			settings: "/admin/community/groups/settings",
			category: {
				url: "/admin/community/groups/category",
				assign: "/admin/community/groups/category/assign",
				order: "/admin/community/groups/category/order"
			},
			users: "/admin/community/groups/users",
			morderator: "/admin/community/groups/users/morderator"
		},
		agora: {
			base: 'https://api.agora.io/dev/v1'
		},
		infra: {
			dns: "/infra/dns",
			dnsVerify: "/infra/dns/verify",
			brandedAuthApp: "/infra/branded-auth/app",
			brandedAuthRegions: "/infra/branded-auth/regions",
			brandedAuthDetail: "/infra/branded-auth/detail",
			brandedAuthCustomHostname: "/infra/branded-auth/custom-hostname",
			brandedAuthCustomHostnameVerify: "/infra/branded-auth/custom-hostname/verify",
			supabaseCredentialsByCommunity: "/infra/supabase/credentials"
		},
		newsletterPlus: {
			url: '/global/newsletter',
			adminList: '/global/newsletter/admin-list',
			analytics: '/global/newsletter/analytics',
			analyticsExport: '/global/newsletter/analytics/export',
			oneAnalytics: '/global/newsletter/one-analytics',
			recipients: '/global/newsletter/recipients',
			preview: '/global/newsletter/preview',
			testSend: '/global/newsletter/test-send',
			send: '/global/newsletter/:newsletterId/send',
			duplicate: '/global/newsletter/:newsletterId/duplicate',
			content: {
				list: '/global/newsletter/content/list',
				lookupByIds: '/global/newsletter/content/lookup-by-ids',
			},
			subscriber: {
				url: '/global/newsletter/subscriber',
				assignList: '/global/newsletter/subscriber/assignList',
				bulkUploadTemplate: '/global/newsletter/subscriber/bulk-upload-template',
				addBulkSubscribers: '/global/newsletter/subscriber/bulk-upload-subscriber',
				byEmail: '/global/newsletter/subscriberbyemail'
			},
			subscriberList: {
				url: '/global/newsletter/subscriberList'
			}
		},
		openAi: { //While making an api call append /openai to the url
			community: {
				create: "/openai/community/create",
				enhance: "/openai/community/enhance",
				chatStream: "/openai/community/chat-stream"
			},
			askOfferHelp: {
				create: "/openai/ask-offer-help/create",
				enhance: "/openai/ask-offer-help/enhance"
			},
			post: {
				create: "/openai/post/create",
				enhance: "/openai/post/enhance"
			},
			event: {
				create: "/openai/event/create",
				enhance: "/openai/event/enhance"
			},
			pollSurvey: {
				create: "/openai/poll-survey/create",
				enhance: "/openai/poll-survey/enhance"
			},
			job: {
				create: "/openai/job/create",
				enhance: "/openai/job/enhance"
			},
			fundraising: {
				create: "/openai/fundraising/create",
				enhance: "/openai/fundraising/enhance"
			},
			companyServices: {
				create: "/openai/company-services/create",
				enhance: "/openai/company-services/enhance"
			}
		},
		// AI Copilot (be-open-ai). The UI talks only to these; the agent reaches the platform through be-open-ai's MCP module (src/mcp).
		copilot: {
			chatStream: "/openai/copilot/chat-stream",
			commitProposal: "/openai/copilot/proposals/commit",
			cancelProposal: "/openai/copilot/proposals/cancel",
			revertAction: "/openai/copilot/actions/revert",
			conversations: "/openai/copilot/conversations",
			conversation: "/openai/copilot/conversations/one",
			wickToday: "/openai/copilot/wick/today",
			wickState: "/openai/copilot/wick/state",
			wickPreferences: "/openai/copilot/wick/preferences",
			wickFeedback: "/openai/copilot/wick/feedback",
			wickPlan: "/openai/copilot/wick/plan",
		},
		puckAi: {
			generate: "/openai/puck/generate",
			enhance: "/openai/puck/enhance",
			editSection: "/openai/puck/edit-section",
			patchProps: "/openai/puck/patch-props",
		},
		global: {
			/** Server-to-server callbacks (no user session): Mattermost outgoing webhook, Open edX event relay. */
			internal: {
				chatWebhookEvent: "/global/chat/webhook-event", //POST
				openEdxEvents: "/global/internal/open-edx/events", //POST
			},
		},
	};
	static formAppV1Url(url: string): string {
		return "/api/v1" + url;
	}

	static formFileV1Url(url: string): string {
		return "/files/v1" + url;
	}
}
